import { render } from "./index.vue?vue&type=template&id=37804eec"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/NotFound/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "37804eec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('37804eec', __exports__)) {
    api.reload('37804eec', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=37804eec", () => {
    api.rerender('37804eec', render)
  })

}


export default __exports__